import StateEvent from "./StateEvent";

class ApiStateListeners {
	private stateListeners: {[key: number]: (e: StateEvent) => void} = {};
	private stateListenerId = 0;

	addStateListener(eventCallback: (e: StateEvent) => void): number {
		const id = this.stateListenerId++;
		this.stateListeners[id] = eventCallback;

		return id;
	}

	fireStateListeners(event: StateEvent): void {
		for(const i in this.stateListeners) {
			this.stateListeners[i](event);
		}
	}

	deleteStateListener(id: number): boolean {
		delete this.stateListeners[id];
		return true;
	}
}

const instance = new ApiStateListeners();

export default instance;
